import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getAccessManagementPermissions} from '../../services/getAccessManagementPermissions';
import {useSelectedPlanStore} from 'presentation/pages/others/selection-flow/store/useSelectedPlanStore';

export function useGetAccessManagementPermissionsQuery() {
	const selectedPlan = useSelectedPlanStore(state => state.selectedPlan);

	return useQuery({
		queryKey: [
			QUERY_KEYS.ACCESS_MANAGEMENT_PERMISSIONS,
			selectedPlan?.cdPlano,
			selectedPlan?.nuContrato,
		],
		queryFn: ({signal}) =>
			getAccessManagementPermissions({
				cdPlano: selectedPlan?.cdPlano,
				nuContrato: selectedPlan?.nuContrato,
				signal,
			}),
		enabled: Boolean(selectedPlan?.cdPlano && selectedPlan?.nuContrato),
		retry: 2,
	});
}
